// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dc3t","tabsBox":"styles_tabsBox__1mSTW","createButton":"styles_createButton__2jvoa"};